import emptyStateImage from "$assets/images/empty-state.svg?url";
import { makeStyles } from "$components/mui-styles";
import { Grid, Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(() => ({
  emptyStateContainer: {
    textAlign: "center",
  },
  emptyStateImage: {
    margin: "20px auto",
    width: "100px",
  },
}));

const EmptySearchState = () => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.emptyStateContainer}>
      <Grid>
        <img className={classes.emptyStateImage} src={emptyStateImage} alt="" />
        <Typography variant="body1">
          <b>
            <FormattedMessage
              id="invoicing.emptySearchState.title"
              defaultMessage="There are no invoices for the status and dates you have selected"
            />
          </b>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default EmptySearchState;
